import axios from "../../../../axios"

export default {
    namespaced: true,
    state: {
        orderServices: [],
        orderServiceOptions: []
    },
    getters: {
        getOrderServices: (state) => state.orderServices,
        getOrderServiceOptions: (state) => state.orderServiceOptions
    },
    mutations: {
        SET_ORDER_SERVICES(state, payload) {
            state.orderServices = payload
        },
        SET_ORDER_SERVICE_OPTIONS(state, payload) {
            state.orderServiceOptions = payload
        },
        REMOVE_ORDER_SERVICE(state, payload) {
            state.orderServices = state.orderServices.filter(orderService => orderService.id != payload.id)
        },
        PUSH_ORDER_SERVICE(state, payload) {
            state.orderServices.push(payload)
        }
    },
    actions: {
        GET_ORDER_SERVICE_OPTIONS() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/service/objednavkove`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}
